<template>
  <div v-if="hasTestScores">
    <AthleteSectionSubheading>Test Scores</AthleteSectionSubheading>
    <div class="mb-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      <div class="w-full" v-if="satScore">
        <AthleteTestScoreCard title="sat" :value="satScore.score" :scale="satScore.scale">
          <div class="flex flex-row">
            <AthleteField label="math" class secondary>
              <p class="m-0 ds-text-xl font-medium text-gray-900">
                <span>{{satScore.mathScore}}</span>
                <span class="text-gray-500">/800</span>
              </p>
            </AthleteField>
            <AthleteField label="reading &amp; writing" class="pl-6" secondary>
              <p class="m-0 ds-text-xl font-medium text-gray-900">
                <span>{{satScore.verbalScore}}</span>
                <span class="text-gray-500">/800</span>
              </p>
            </AthleteField>
          </div>
        </AthleteTestScoreCard>
      </div>
      <div class="w-full" v-if="actScore && actScore.score > 0">
        <AthleteTestScoreCard title="act" :value="actScore.score" :scale="actScore.scale" />
      </div>
      <div
        class="w-full"
        v-for="(score, index) in sat2Scores"
        :key="index"
        v-if="score && score.score > 0"
      >
        <AthleteTestScoreCard title="sat subject test" :value="score.score" :scale="score.scale">
          <AthleteField label="Subject" class secondary>
            <p class="m-0 ds-text-xl font-semibold text-gray-900">{{score.subject}}</p>
          </AthleteField>
        </AthleteTestScoreCard>
      </div>

      <div class="w-full" v-if="psatScore && psatScore.score > 0">
        <AthleteTestScoreCard title="psat" :value="psatScore.score" :scale="psatScore.scale">
          <div class="flex flex-row">
            <AthleteField label="math" class secondary>
              <p class="m-0 ds-text-xl font-medium text-gray-900">
                <span>{{psatScore.mathScore}}</span>
                <span class="text-gray-500">/760</span>
              </p>
            </AthleteField>
            <AthleteField label="reading &amp; writing" class="pl-6" secondary>
              <p class="m-0 ds-text-xl font-medium text-gray-900">
                <span>{{psatScore.verbalScore}}</span>
                <span class="text-gray-500">/760</span>
              </p>
            </AthleteField>
          </div>
        </AthleteTestScoreCard>
      </div>
    </div>
  </div>
</template>

<script>
import AthleteField from "../../AthleteField.vue";
import AthleteTestScoreCircle from "./AthleteTestScoreCircle.vue";
import { mapState, mapGetters } from "vuex";
import AthleteTestScoreCard from "./AthleteTestScoreCard.vue";
import AthleteSectionSubheading from "../../AthleteSectionSubheading.vue";

export default {
  components: {
    AthleteField,
    AthleteTestScoreCircle,
    AthleteTestScoreCard,
    AthleteSectionSubheading
  },
  computed: {
    ...mapState({
      user: state => state.athleteProfile.user
    }),
    ...mapGetters({
      isLoggedOut: "userData/isLoggedOut",
      satScore: "athleteProfile/satScore",
      actScore: "athleteProfile/actScore",
      sat2Scores: "athleteProfile/sat2Scores",
      psatScore: "athleteProfile/psatScore",
      hasTestScores: "athleteProfile/hasTestScores"
    })
  }
};
</script>
